import React, { useState, useEffect } from "react";
import {
  Box,
  Button,
  Modal,
  TextField,
  IconButton,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import CancelIcon from "@mui/icons-material/Cancel";
import DeleteIcon from "@mui/icons-material/Delete";
import SaveIcon from "@mui/icons-material/Save";

const DaysModal = ({ contract, open, onClose, handleChangeDatas }) => {
  const [days, setDays] = useState(contract?.nrZile || "");
  const [confirmDeleteOpen, setConfirmDeleteOpen] = useState(false);

  const BASE_URL = process.env.REACT_APP_BASE_URL;

  useEffect(() => {
    if (contract) {
      setDays(contract.nrZile || "");
    }
  }, [contract]);

  const handleSave = async () => {
    try {
      const response = await fetch(`${BASE_URL}/updateDays`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({ ContractId: contract.idContract, days })
      });

      if (response.ok) {
        handleChangeDatas();
        onClose();
      } else {
        console.error("Eroare la salvarea numărului de zile");
      }
    } catch (error) {
      console.error("Eroare de rețea:", error);
    }
  };

  const handleDeleteConfirm = () => {
    setConfirmDeleteOpen(true); // Deschide dialogul de confirmare
  };

  const handleDelete = async () => {
    try {
      const response = await fetch(`${BASE_URL}/deleteDays`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({ ContractId: contract.idContract })
      });

      if (response.ok) {
        handleChangeDatas();
        onClose();
      } else {
        console.error("Eroare la ștergerea numărului de zile");
      }
      setConfirmDeleteOpen(false); // Închide dialogul de confirmare
    } catch (error) {
      console.error("Eroare de rețea:", error);
    }
  };

  return (
    <>
      <Modal open={open} onClose={onClose}>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "400px",
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 4,
            borderRadius: "10px"
          }}
        >
          {/* Butonul de închidere (X) */}
          <IconButton
            onClick={onClose}
            sx={{
              position: "absolute",
              top: 8,
              right: 8,
              color: "red"
            }}
          >
            <CloseIcon />
          </IconButton>

          <h4 style={{ paddingTop: "30px", paddingBottom: "20px" }}>
            Adaugă/Editează număr de zile
          </h4>
          <TextField
            label="Număr de Zile"
            type="number"
            fullWidth
            value={days}
            onChange={(e) => setDays(e.target.value)}
            sx={{ marginBottom: 2 }}
          />

          <Box sx={{ display: "flex", justifyContent: "space-between" }}>
            <Button
              variant="outlined"
              onClick={handleSave}
              startIcon={<SaveIcon />}
            >
              Salvează
            </Button>
            <Button
              variant="outlined"
              color="error"
              onClick={handleDeleteConfirm}
              startIcon={<DeleteIcon />}
            >
              Șterge
            </Button>
          </Box>
        </Box>
      </Modal>

      <Dialog
        open={confirmDeleteOpen}
        onClose={() => setConfirmDeleteOpen(false)}
        sx={{ textAlign: "center", padding: "20px" }}
      >
        <DialogTitle>Confirmare ștergere</DialogTitle>
        <DialogContent>
          <p>Ești sigur că vrei să ștergi?</p>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => setConfirmDeleteOpen(false)}
            color="primary"
            variant="outlined"
            startIcon={<CancelIcon />}
          >
            Anulează
          </Button>
          <Button
            onClick={handleDelete} // Funcția care efectuează ștergerea
            color="error"
            variant="outlined"
            startIcon={<DeleteIcon />}
          >
            Șterge
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default DaysModal;
